//#region recipes/leftbar/unread_pill/unread_pill_constants.js
var e = ["up", "down"], t = ["mentions", "messages"], n = {
	UNREAD_PILL_DIRECTIONS: e,
	UNREAD_PILL_KINDS: t
};
//#endregion
export { e as UNREAD_PILL_DIRECTIONS, t as UNREAD_PILL_KINDS, n as default };

//# sourceMappingURL=unread-pill-constants.js.map